import moment from 'moment';
import { isPresent } from 'helpers/string_helpers';

import { setLastSelectedCallListId } from '../../local_storage';

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return { type: CLEAR_FILTERS };
}

export const CHANGE_ASSIGNEE_FILTER = 'CHANGE_ASSIGNEE_FILTER';
export function changeAssigneeFilter(assigneeId) {
  return { id: assigneeId, type: CHANGE_ASSIGNEE_FILTER };
}

export const CHANGE_CREATOR_FILTER = 'CHANGE_CREATOR_FILTER';
export function changeCreatorFilter(creatorId) {
  return { id: creatorId, type: CHANGE_CREATOR_FILTER };
}

export const CHANGE_END_DATE_FILTER = 'CHANGE_END_DATE_FILTER';
export function changeEndDateFilter(date) {
  return { date, type: CHANGE_END_DATE_FILTER };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(text) {
  return { text, type: CHANGE_SEARCH_TEXT };
}

export const CHANGE_START_DATE_FILTER = 'CHANGE_START_DATE_FILTER';
export function changeStartDateFilter(date) {
  return (dispatch, getState) => {
    dispatch({ date, type: CHANGE_START_DATE_FILTER });

    const startDate = isPresent(date) ? moment(date) : null;

    if (startDate) {
      let endDate = getState().query.endDate;
      endDate = isPresent(endDate) ? moment(endDate) : null;

      if (endDate && endDate.isBefore(startDate)) {
        dispatch(changeEndDateFilter(date));
      }
    }
  };
}

export const CHANGE_STATUS_FILTER = 'CHANGE_STATUS_FILTER';
export function changeStatusFilter(type) {
  return { status: type, type: CHANGE_STATUS_FILTER };
}

export const CHANGE_TASK_TYPE_FILTER = 'CHANGE_TASK_TYPE_FILTER';
export function changeTaskTypeFilter(type) {
  return { taskType: type, type: CHANGE_TASK_TYPE_FILTER };
}

export const SET_CALL_LIST_ID = 'SET_CALL_LIST_ID';
export const setCallListId = (callListId) => {
  setLastSelectedCallListId(callListId);
  return { type: SET_CALL_LIST_ID, callListId };
};

export function resetAssigneeFilter() {
  return (dispatch, getState) => {
    const currentUser = getState().static.currentUser;
    dispatch(changeAssigneeFilter(currentUser.id));
  };
}

export const CHANGE_TAGS_FILTER = 'CHANGE_TAGS_FILTER';
export function changeTagsFilter(tagIds) {
  return { tagIds: tagIds, type: CHANGE_TAGS_FILTER };
}

export const TOGGLE_INCLUDE_UNTAGGED = 'TOGGLE_INCLUDE_UNTAGGED';
export function toggleIncludeUntagged() {
  return { type: TOGGLE_INCLUDE_UNTAGGED };
}
